<div class="data-grid-row d-flex flex-row align-items-center justify-content-start" [ngClass]="type">
<ng-content></ng-content>
</div>
